window.cselect = {

  init: () => {
    window.cselect.addListeners();
  },

  addListeners: () => {
    let cselects = document.querySelectorAll('.cselect:not(.event_is_set)');
    if (cselects.length) {
      cselects.forEach((item) => {
        let selected = item.querySelector('.cselect__selected'),
            single_options = item.querySelectorAll('.cselect__option');
        selected.addEventListener('click', (item) => {
          window.cselect.toggleOptions(item.currentTarget.closest('.cselect'));
        });
        single_options.forEach((single_option) => {
          single_option.addEventListener('click', () => {
            let index = parseFloat(single_option.getAttribute('data-index')),
                next_element = item.nextElementSibling;

            if (next_element && next_element.classList.contains('select')) {
              let select = next_element.querySelector('select'),
                  event = new Event('change', { bubbles: true }),
                  selected_text = item.querySelector('.cselect__selected__text'),
                  cselect_name = item.getAttribute('data-cselect-name'),
                  data_submit_on_change = item.getAttribute('data-submit-on-change');

              select.selectedIndex = index;
              select.dispatchEvent(event);
              selected_text.innerHTML = single_option.innerHTML;

              window.cselect.hideAllOptions();

              if (data_submit_on_change == 'true') {
                item.closest('form').submit();
              }
            }
          });
        })
        item.classList.add('event_is_set');
      });

      document.addEventListener('click', function(event) {
        let inside = false;
        cselects.forEach(div => {
          if (div.contains(event.target)) {
            inside = true;
          }
        });
        if (!inside) {
          cselects.forEach(div => {
            div.classList.remove('is_active');
          });
        }
      });
    }
  },

  toggleOptions: (item) => {
    if (item.classList.contains('is_active')) {
      window.cselect.hideOptions(item);
    } else {
      window.cselect.showOptions(item);
    }
  },

  showOptions: (item) => {
    item.classList.add('is_active');
  },

  hideOptions: (item) => {
    item.classList.remove('is_active');
  },

  hideAllOptions: () => {
    let cselects = document.querySelectorAll('.cselect');
    if (cselects.length) {
      cselects.forEach((item) => {
        item.classList.remove('is_active');
      });
    }
  }

};

window.cselect.init();
